<div
  class="freigabe-kachel"
  data-testid="freigabe-kachel"
  role="link"
  tabindex="0"
  [attr.data-ampel]="ampel()"
  (click)="open()"
  (keydown.enter)="open()"
>
  <button
    type="button"
    class="freigabe-kachel__remove"
    data-testid="freigabe-kachel-entfernen"
    [attr.aria-label]="'liveDashboard.freigabeStatus.remove' | translate"
    [matTooltip]="'liveDashboard.freigabeStatus.removeTooltip' | translate"
    (click)="onRemove($event)"
    (keydown.enter)="$event.stopPropagation()"
  >
    <mat-icon aria-hidden="true">close</mat-icon>
  </button>

  <div class="freigabe-kachel__title">
    {{ 'liveDashboard.freigabeStatus.release' | translate: { id: pin().releaseId } }}
  </div>
  <div class="freigabe-kachel__sub">
    @if (showProject()) {
      {{ pin().projectName }} ·
    }
    @if (environmentLabel(); as environment) {
      {{ 'liveDashboard.freigabeStatus.environment' | translate: { name: environment } }}
    } @else {
      {{ 'liveDashboard.freigabeStatus.allEnvironments' | translate }}
    }
    @if (planCount() !== null) {
      · {{ 'liveDashboard.freigabeStatus.plans' | translate: { count: planCount() } }}
    }
  </div>

  @switch (state()) {
    @case ('loaded') {
      <span class="freigabe-kachel__badge">{{ 'liveDashboard.freigabeStatus.ampel.' + ampel() | translate }}</span>
      <div class="freigabe-kachel__kpis">
        <div>
          <div class="freigabe-kachel__kpi-label">{{ 'liveDashboard.freigabeStatus.kpi.passRate' | translate }}</div>
          <div class="freigabe-kachel__kpi-value">{{ passRate() }}%</div>
        </div>
        <div>
          <div class="freigabe-kachel__kpi-label">{{ 'liveDashboard.freigabeStatus.kpi.executed' | translate }}</div>
          <div class="freigabe-kachel__kpi-value">{{ executed() }}%</div>
        </div>
        <div>
          <div class="freigabe-kachel__kpi-label">{{ 'liveDashboard.freigabeStatus.kpi.blocker' | translate }}</div>
          <div class="freigabe-kachel__kpi-value">
            {{ blockerCount() }}
            @if (criticalCount() > 0) {
              · {{ 'liveDashboard.freigabeStatus.kritisch' | translate: { count: criticalCount() } }}
            }
          </div>
        </div>
      </div>
    }
    @case ('loading') {
      <span class="freigabe-kachel__placeholder freigabe-kachel__placeholder--badge" aria-hidden="true"></span>
      <div class="freigabe-kachel__kpis" aria-hidden="true">
        @for (kpi of ['passRate', 'executed', 'blocker']; track kpi) {
          <div>
            <div class="freigabe-kachel__kpi-label">{{ 'liveDashboard.freigabeStatus.kpi.' + kpi | translate }}</div>
            <span class="freigabe-kachel__placeholder freigabe-kachel__placeholder--value"></span>
          </div>
        }
      </div>
    }
    @case ('error') {
      <p class="freigabe-kachel__unavailable">{{ 'liveDashboard.freigabeStatus.unavailable' | translate }}</p>
    }
  }
</div>
